import React from 'react';
import { connect } from 'react-redux';
import Text from '@bit/knotchinc.web-react-components.text';
import ContentFilterItem from './ContentFilterItem.jsx';
import { ContentFilterWrapper, ContentFilterItemContainer } from './styled.js';

export const ContentFilter = props => {
  const { filterAction, filters, setFilters } = props;
  const selectedType = filters.content_type;
  const options = ['paid', 'owned'];
  return (
    <ContentFilterWrapper>
      <Text textTransform="capitalize" fontSize={14}>
        Content
      </Text>
      <ContentFilterItemContainer>
        {options.map((option, i) =>
          <ContentFilterItem
            type={option}
            selectedType={selectedType}
            key={`filter_content_${i}`}
            onClick={(type) => setFilters(filterAction, type === filters.content_type ? '' : type)}
          />)}
      </ContentFilterItemContainer>
    </ContentFilterWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  setFilters: (type, contentType) => dispatch({ type, filters: { content_type: contentType, pageNum: 1 } }),
});

export default connect(null, mapDispatchToProps)(ContentFilter);
